import * as d3 from 'd3';
import { DirectGeometryObject, Feature } from 'geojson';

export type Shapes = { [index: string]: Feature<DirectGeometryObject> };
type Callback = (shapes: Shapes, load: Load) => void;
export type Load = (callback: Callback) => void;

/**
 * Load one or more shape files.
 * @param countryCodes List of country codes to load.
 * @param callback     Callback with the country codes as the data once all have been loaded.
 */
function loadMaps(countryCodes: string[], callback: (shapes: Shapes) => void): void {
    const shapes: Shapes = {};
    let count = 0;
    for (let countryCode of countryCodes) {
        const fileName = `data/shapes/${countryCode.toLowerCase()}.geo.json`;
        d3.json(fileName, function (data: Feature<DirectGeometryObject>) {
            shapes[countryCode] = data;
            count++;
            if (count >= countryCodes.length) {
                callback(shapes);
            }
        });
    }
}

export default function (countryCodes: string[][]): Load {
    let index = 0;
    const load: Load = function (callback: Callback): void {
        index++;
        loadMaps(countryCodes[index], function (shapes: Shapes) {
            callback(shapes, load);
        });
    };
    return load;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utilities/load-maps.ts